import { useDashboardData } from "../context/DashboardDataContext";
import { formatPct, PATTERNS, PATTERN_LABELS, DIMENSIONS, DIMENSION_LABELS } from "../dashboard/analytics";
import { Card } from "../components/ui/Card";
import { PageHeader } from "../components/ui/PageHeader";

export function CohortsTrends() {
  const { analytics } = useDashboardData();

  const quarters = Object.entries(analytics.quarterPattern).sort((a, b) =>
    a[0].localeCompare(b[0])
  );

  return (
    <div className="page">
      <PageHeader
        eyebrow="Cohorts & trends"
        title="Momentum over time"
        description="Quarterly primary-pattern counts and revenue-segment reactivity."
      />

      <Card title="Pattern trends by quarter" subtitle="Primary pattern frequency">
        <div className="table-wrap table-wrap--rounded">
          <table className="data-table">
            <thead>
              <tr>
                <th>Quarter</th>
                {PATTERNS.map((p) => (
                  <th key={p}>{PATTERN_LABELS[p] || p}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {quarters.length ? (
                quarters.map(([q, vals]) => (
                  <tr key={q}>
                    <td>{q}</td>
                    {PATTERNS.map((p) => (
                      <td key={p}>{vals[p]}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={PATTERNS.length + 1} className="muted">
                    No dated submissions in range.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      <Card title="Revenue cohort — dependency loop share" subtitle="Lower revenue vs higher — who shows Dependency Loop as primary bottleneck most?">
        <div className="table-wrap table-wrap--rounded">
          <table className="data-table">
            <thead>
              <tr>
                <th>Revenue band</th>
                <th>Assessments</th>
                <th>Dependency loop share</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(analytics.reactiveByRevenue)
                .sort((a, b) => a[0].localeCompare(b[0]))
                .map(([rev, row]) => (
                  <tr key={rev}>
                    <td>{rev}</td>
                    <td>{row.total}</td>
                    <td>{formatPct(row.total ? row.reactive / row.total : 0)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Card>

      <Card title="Dimension score by revenue (avg /9)" subtitle="Scored dimensions by ARR band">
        <div className="table-wrap table-wrap--rounded">
          <table className="data-table data-table--compact">
            <thead>
              <tr>
                <th>Revenue</th>
                {DIMENSIONS.map((dim) => (
                  <th key={dim}>{DIMENSION_LABELS[dim].replace(" Architecture", "").replace(" Structure", "").replace(" Signal", "")}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(analytics.revenuePattern).map(([rev, vals]) => (
                <tr key={rev}>
                  <td>{rev}</td>
                  {DIMENSIONS.map((dim) => {
                    const cell = vals[dim];
                    const avg = cell?.count ? (cell.sum / cell.count).toFixed(1) : "—";
                    return <td key={dim}>{avg}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
